import React from "react";
import { FaArrowLeft, FaBars, FaAngleRight } from "react-icons/fa";
import { useBlueBody } from "../hooks/useBlueBody";

import * as SCREENS from "../constants/screens";
import * as ADMINS from "../constants/admins";

import BBIcon from "../assets/icons/bb.svg";
import ItauIcon from "../assets/icons/itau.svg";
import CaixaIcon from "../assets/icons/caixa.svg";
import SantanderIcon from "../assets/icons/santander.svg";
import VolkswagenIcon from "../assets/icons/volkswagen.svg";
import YamahaIcon from "../assets/icons/yamaha.svg";
import UnifisaIcon from "../assets/icons/unifisa.svg"
import ServopaIcon from "../assets/icons/servopa.svg"

import AdministratorCard from "./administrator-card";

export default function Administrators({ dataManager, sidebarManager }) {
  const { data, setData } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    const screen = data.associateMode && SCREENS.WELCOME;
    setData({ ...data, screen: screen });
  }

  function nextScreen(administrator, uri, screen = SCREENS.NAME) {
    data.associateMode ?
    setData({
      ...data,
      administrator: administrator,
      screen: screen,
      formURI: uri,
    }) :
    setData({
      ...data,
      administrator: administrator,
      screen: SCREENS.FINALITY,
    })
  }

  console.log('adm page', data)

  return (
    <section className="administrators-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "20%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="20"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Simulação de Consórcios</h1>
        <h2>Selecione a administradora desejada.</h2>
      </div>
      <div className="bottom-panel container">
        {data.associateMode ?
          <div className="row">
            <AdministratorCard icon={BBIcon} name={ADMINS.BB_NAME} uri={ADMINS.BB_URI} nextScreen={nextScreen} />
            <AdministratorCard icon={ItauIcon} name={ADMINS.ITAU_NAME} uri={ADMINS.ITAU_URI} nextScreen={nextScreen} />
            <AdministratorCard icon={CaixaIcon} name={ADMINS.CAIXA_NAME} uri={ADMINS.CAIXA_URI} nextScreen={nextScreen} />
            <AdministratorCard icon={SantanderIcon} name={ADMINS.SANTANDER_NAME} uri={ADMINS.SANTANDER_URI} nextScreen={nextScreen} />
            {/* <AdministratorCard icon={VolkswagenIcon} name={ADMINS.CNVW_NAME} uri={ADMINS.CNVW_URI} nextScreen={nextScreen}/> */}
            <AdministratorCard icon={UnifisaIcon} name={ADMINS.UNIFISA_NAME} uri={ADMINS.UNIFISA_URI} nextScreen={nextScreen}/>
            <AdministratorCard icon={YamahaIcon} name={ADMINS.YAMAHA_NAME} uri={ADMINS.YAMAHA_URI} nextScreen={nextScreen}/>
            <AdministratorCard icon={ServopaIcon} name={ADMINS.SERVOPA_NAME} uri={ADMINS.SERVOPA_URI} screen={SCREENS.SERVOPA_OPTIONS} nextScreen={nextScreen}/>
          </div>
          :
          <div className="row">

            <div className="col-12 col-md-6 col-lg-4 d-flex">
              <div
                className="card card-body card-results text-dark mb-2"
                role="button"
                tabIndex="0"
                onClick={(e) => nextScreen(ADMINS.BB_NAME)}
                onKeyDown={(e) => e.target.onClick}
              >
                <div className="row justify-content-between mb-2">
                  <div className="col">
                    <img
                      src={BBIcon}
                      className="icon-card"
                      alt="Icone para representar BB"
                    />
                  </div>
                  <div className="col-auto">
                    <FaAngleRight className="hire-results" />
                  </div>
                </div>
                <p className="mt-auto mb-0">
                  <strong>{ADMINS.BB_NAME}</strong>
                </p>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  );
}
